import React, { useState, useEffect } from "react";
import ListItemButton from "@mui/material/ListItemButton";
import axios from "axios";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import TvIcon from "@mui/icons-material/Tv";
import LogoutIcon from "@mui/icons-material/Logout";
import DashboardIcon from "@material-ui/icons/Dashboard";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListSubheader from "@material-ui/core/ListSubheader";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ReceiptIcon from "@mui/icons-material/Receipt";
import Divider from "@mui/material/Divider";
import Swal from "sweetalert2";
import {
  Grid,
  TextField,
  Box,
  Link,
  Button,
  Dialog,
  Slide,
  Typography,
} from "@mui/material";
import ArticleIcon from "@mui/icons-material/Article";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";
import AppRegistrationIcon from "@mui/icons-material/AppRegistration";
import MessageIcon from "@mui/icons-material/Message";
import { loginState, configState } from "../lib/State";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import pr from "../lib/pr";
import MoreTimeIcon from "@mui/icons-material/MoreTime";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import KeyIcon from "@mui/icons-material/Key";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import LocalAtmIcon from "@mui/icons-material/LocalAtm";
import Collapse from "@mui/material/Collapse";
import PaymentIcon from "@mui/icons-material/Payment";
import SdCardIcon from "@mui/icons-material/SdCard";
import SpeakerNotesIcon from "@mui/icons-material/SpeakerNotes";
import DescriptionIcon from "@mui/icons-material/Description";
import SettingsIcon from "@mui/icons-material/Settings";
import CampaignIcon from "@mui/icons-material/Campaign";
import AssignmentIcon from "@mui/icons-material/Assignment";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import ContactMailIcon from "@mui/icons-material/ContactMail";
import EventIcon from "@mui/icons-material/Event";

const LayoutMenu = (props) => {
  const [fold, setFlod] = useState({
    0: false,
    1: false,
    2: false,
    3: false,
    4: false,
  });
  const { login } = props;

  const onLogout = () => {
    Swal.fire({
      title: "로그아웃 하시겠습니까?",
      showCancelButton: true,
      sconfirmButtonText: "예",
      cancelButtonText: "아니오",
      closeOnCalcel: true,
    }).then((result) => {
      if (result.isConfirmed == true) {
        localStorage.setItem("token", "");
        window.location.href = "/";
      }
    });
  };

  const onCollapse = (target) => {
    setFlod((state) => {
      state[target] = !state[target];
      return { ...state, state };
    });
    console.log(fold);
    //let newState = getCollapse;
    //newState[target] = !newState[target];
  };

  return (
    <Box>
      <ListItemButton component="a" href="/home">
        <ListItemIcon>
          <DashboardIcon />
        </ListItemIcon>
        <ListItemText primary="대시보드" />
      </ListItemButton>
      <Divider />

      {/* 지점관리자 */}
      {login.level === "100" && (
        <>
          <ListItemButton component="a" href="#" onClick={() => onCollapse(0)}>
            <ListItemIcon>
              <PaymentIcon />
            </ListItemIcon>
            <ListItemText primary="결제관리" />
          </ListItemButton>
          <Collapse in={fold[0]} sx={{ pl: 1 }}>
            <ListItemButton component="a" href="/order">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="구매관리" />
            </ListItemButton>
            <ListItemButton component="a" href="/coupon">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="쿠폰관리" />
            </ListItemButton>
          </Collapse>

          <ListItemButton
            component="a"
            href="#"
            onClick={() => onCollapse(3)}
            sx={{ borderTop: 1, borderTopColor: "#adb5bd" }}
          >
            <ListItemIcon>
              <PaymentIcon />
            </ListItemIcon>
            <ListItemText primary="환불관리" />
          </ListItemButton>
          <Collapse in={fold[3]} sx={{ pl: 1 }}>
            <ListItemButton component="a" href="/refund">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="환불관리" />
            </ListItemButton>
            <ListItemButton component="a" href="/return">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="쿠폰반환관리" />
            </ListItemButton>
          </Collapse>
          <Divider />

          <ListItemButton component="a" href="#" onClick={() => onCollapse(1)}>
            <ListItemIcon>
              <ArticleIcon />
            </ListItemIcon>
            <ListItemText primary="예약관리" />
          </ListItemButton>
          <Collapse in={fold[1]} sx={{ pl: 1 }}>
            <ListItemButton component="a" href="/reservation">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="예약보드" />
            </ListItemButton>
            <ListItemButton component="a" href="/reservation_log">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="예약로그" />
            </ListItemButton>
            <ListItemButton component="a" href="/frequency">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="프리퀀시" />
            </ListItemButton>
            <ListItemButton component="a" href="/gift">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="사은품신청" />
            </ListItemButton>
          </Collapse>
          <Divider></Divider>
          <ListItemButton component="a" href="/member">
            <ListItemIcon>
              <AccountBoxIcon />
            </ListItemIcon>
            <ListItemText primary="회원관리" />
          </ListItemButton>
          <ListItemButton component="a" href="/teacher">
            <ListItemIcon>
              <AccountBoxIcon />
            </ListItemIcon>
            <ListItemText primary="강사관리" />
          </ListItemButton>
          <ListItemButton component="a" href="/resume">
            <ListItemIcon>
              <DescriptionIcon />
            </ListItemIcon>
            <ListItemText primary="이력서관리" />
          </ListItemButton>
          <ListItemButton component="a" href="/push">
            <ListItemIcon>
              <MessageIcon />
            </ListItemIcon>
            <ListItemText primary="푸시관리" />
          </ListItemButton>
        </>
      )}

      {/* 최과관리자 */}
      {login.level === "500" && (
        <>
          <ListItemButton component="a" href="#" onClick={() => onCollapse(0)}>
            <ListItemIcon>
              <PaymentIcon />
            </ListItemIcon>
            <ListItemText primary="결제관리" />
          </ListItemButton>
          <Collapse in={fold[0]} sx={{ pl: 1 }}>
            <ListItemButton component="a" href="/order">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="구매관리" />
            </ListItemButton>
            <ListItemButton component="a" href="/order_log">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="구매관리(로그)" />
            </ListItemButton>
            <ListItemButton component="a" href="/coupon">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="쿠폰관리" />
            </ListItemButton>
            <ListItemButton component="a" href="/coupon_log">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="쿠폰관리(로그)" />
            </ListItemButton>
            <ListItemButton component="a" href="/dcoupon">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="할인쿠폰관리" />
            </ListItemButton>
            <ListItemButton component="a" href="/dcoupon_issue">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="할인쿠폰관리(발행)" />
            </ListItemButton>
            <ListItemButton component="a" href="/point">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="포인트 관리" />
            </ListItemButton>
            <ListItemButton component="a" href="/point_log">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="포인트관리(로그)" />
            </ListItemButton>
          </Collapse>
          <Divider></Divider>

          <ListItemButton component="a" href="#" onClick={() => onCollapse(3)}>
            <ListItemIcon>
              <PaymentIcon />
            </ListItemIcon>
            <ListItemText primary="환불관리" />
          </ListItemButton>
          <Collapse in={fold[3]} sx={{ pl: 1 }}>
            <ListItemButton component="a" href="/refund">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="환불관리" />
            </ListItemButton>
            <ListItemButton component="a" href="/return">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="쿠폰반환관리" />
            </ListItemButton>
          </Collapse>
          <Divider></Divider>

          <ListItemButton component="a" href="#" onClick={() => onCollapse(1)}>
            <ListItemIcon>
              <ArticleIcon />
            </ListItemIcon>
            <ListItemText primary="예약관리" />
          </ListItemButton>
          <Collapse in={fold[1]} sx={{ pl: 1 }}>
            <ListItemButton component="a" href="/reservation">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="예약보드" />
            </ListItemButton>
            <ListItemButton component="a" href="/reservation_log">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="예약로그" />
            </ListItemButton>
            <ListItemButton component="a" href="/frequency">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="프리퀀시" />
            </ListItemButton>
            <ListItemButton component="a" href="/gift">
              <ListItemIcon>
                <SpeakerNotesIcon />
              </ListItemIcon>
              <ListItemText primary="사은품신청" />
            </ListItemButton>
          </Collapse>
          <Divider></Divider>

          <ListItemButton component="a" href="/item">
            <ListItemIcon>
              <CardGiftcardIcon />
            </ListItemIcon>
            <ListItemText primary="상품관리" />
          </ListItemButton>

          <ListItemButton component="a" href="/member">
            <ListItemIcon>
              <AccountBoxIcon />
            </ListItemIcon>
            <ListItemText primary="회원관리" />
          </ListItemButton>

          <ListItemButton component="a" href="/teacher">
            <ListItemIcon>
              <AccountBoxIcon />
            </ListItemIcon>
            <ListItemText primary="강사관리" />
          </ListItemButton>
          <ListItemButton component="a" href="/resume">
            <ListItemIcon>
              <DescriptionIcon />
            </ListItemIcon>
            <ListItemText primary="이력서관리" />
          </ListItemButton>
          <ListItemButton component="a" href="/push">
            <ListItemIcon>
              <MessageIcon />
            </ListItemIcon>
            <ListItemText primary="푸시관리" />
          </ListItemButton>
          <ListItemButton component="a" href="/basecode">
            <ListItemIcon>
              <SettingsIcon />
            </ListItemIcon>
            <ListItemText primary="코드관리" />
          </ListItemButton>
          <ListItemButton component="a" href="/whatsnew">
            <ListItemIcon>
              <EventIcon />
            </ListItemIcon>
            <ListItemText primary="What's New" />
          </ListItemButton>
        </>
      )}

      {/* 공통 */}
      <Divider></Divider>
      <ListItemButton component="a" href="#" onClick={() => onCollapse(4)}>
        <ListItemIcon>
          <PaymentIcon />
        </ListItemIcon>
        <ListItemText primary="리포트" />
      </ListItemButton>
      <Collapse in={fold[4]} sx={{ pl: 1 }}>
        <ListItemButton component="a" href="/report_card">
          <ListItemIcon>
            <SpeakerNotesIcon />
          </ListItemIcon>
          <ListItemText primary="카드매출" />
        </ListItemButton>
        <ListItemButton component="a" href="/report_coupon">
          <ListItemIcon>
            <SpeakerNotesIcon />
          </ListItemIcon>
          <ListItemText primary="쿠폰매출" />
        </ListItemButton>
        <ListItemButton component="a" href="/report_marketing">
          <ListItemIcon>
            <CampaignIcon />
          </ListItemIcon>
          <ListItemText primary="마케팅 활동 보고서" />
        </ListItemButton>
        <ListItemButton component="a" href="/report_fc">
          <ListItemIcon>
            <PlaylistAddCheckCircleIcon />
          </ListItemIcon>
          <ListItemText primary="FC 업무 보고서" />
        </ListItemButton>
        {/* 마케팅 문항 관리 */}
        {login.level === "500" && (
          <ListItemButton component="a" href="/report_marketing_question">
            <ListItemIcon>
              <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="보고서 문항 관리" />
          </ListItemButton>
        )}
        {/* 가맹점 문의 */}
        {login.level === "500" && (
          <ListItemButton component="a" href="/board?id=ask">
            <ListItemIcon>
              <ContactMailIcon />
            </ListItemIcon>
            <ListItemText primary="가맹문의" />
          </ListItemButton>
        )}
      </Collapse>

      <Divider></Divider>
      <ListItemButton component="a" href="/review">
        <ListItemIcon>
          <DescriptionIcon />
        </ListItemIcon>
        <ListItemText primary="리뷰이벤트" />
      </ListItemButton>

      <ListItemButton component="a" href="/center_open">
        <ListItemIcon>
          <MoreTimeIcon />
        </ListItemIcon>
        <ListItemText primary="운영시간관리" />
      </ListItemButton>

      <ListItemButton component="a" href="/smart_key">
        <ListItemIcon>
          <KeyIcon />
        </ListItemIcon>
        <ListItemText primary="스마트키관리" />
      </ListItemButton>

      <Box sx={{ height: 40 }}></Box>
      <Divider />
      <Box
        sx={{
          bgcolor: "rgba(71, 98, 130, 0.2)",
          pb: 0,
        }}
      >
        <ListItemButton>
          <ListItemIcon>
            <LogoutIcon />
          </ListItemIcon>
          <ListItemText primary="로그아웃" onClick={onLogout} />
        </ListItemButton>
      </Box>
    </Box>
  );
};

export default LayoutMenu;
